/* @flow */

import { URLBuilder } from 'url-builder/url-builder';
import { Link } from 'lib/ui/link';

export class CategoryLink extends Link {
    constructor(category: Category, urlBuilder = URLBuilder.defaultURLBuilder) {
        super({
            href: () => urlBuilder.getUrl({ url: 'blog/slug', value: { slug: category && category.slug } }),
            label: () => category && category.name,
        });
        this.category = category;
    }
}
